<mdb-navbar SideClass="navbar navbar-dark navbar-expand-xl indigo lighten-1 pt-0 pb-0" [containerInside]="false">
    <logo>
      <span class="white-text">{{ Localization.Jobs | translate }}</span>
    </logo>
    <ul class="navbar-nav ml-auto"
        data-cy="job-boards-navigation">
        <li class="nav-item">
            <a routerLink="list" routerLinkActive="bold amber-text" class="nav-link waves-light" mdbRippleRadius>
                <span>{{ Localization.Processing | translate }}</span>
            </a>
        </li>
        <li class="nav-item nav-item-separator"><span class="nav-link">|</span></li>
        <li class="nav-item">
            <a routerLink="interventions" queryParamsHandling="merge" routerLinkActive="bold amber-text" class="nav-link waves-light" mdbRippleRadius>
                <span>{{ Localization.AssignBoard | translate }}</span>
            </a>
        </li>
        <li class="nav-item nav-item-separator"><span class="nav-link">|</span></li>
        <li class="nav-item">
            <a routerLink="team-overview" routerLinkActive="bold amber-text" class="nav-link waves-light"
               mdbRippleRadius>
                <span>{{ Localization.TeamOverview | translate }}</span>
            </a>
        </li>
    </ul>
</mdb-navbar>
<router-outlet></router-outlet>
